import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

import useLogout from "../hooks/useLogout";

interface AuthError {
  code: string;
  message: string;
}

export const handleAuthError = async (
  error: unknown,
  navigate: ReturnType<typeof useNavigate>,
  handleLogout: ReturnType<typeof useLogout>,
  lang: string
) => {
  if (error instanceof AxiosError) {
    const authError = error.response?.data as AuthError;

    switch (authError?.code) {
      case "TOKEN_EXPIRED":
      case "INVALID_TOKEN":
        await handleLogout();
        navigate(`/${lang}/auth/login`);
        break;
      case "RATE_LIMIT_EXCEEDED":
        // Show rate limit exceeded message
        break;
      case "SESSION_EXPIRED":
        await handleLogout();
        navigate(`/${lang}/auth/login`);
        break;
      default:
        console.error("Authentication error:", error);
        break;
    }
  } else {
    console.error("Unexpected error:", error);
  }
};

export const isAuthError = (error: unknown): error is AxiosError => {
  return (
    error instanceof AxiosError &&
    typeof error.response?.data === "object" &&
    "code" in (error.response.data as object)
  );
};
